import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from './Model';

export interface IReferralTypeModel extends IModel {
  referralTypeId: number;
  name: string;
}

export class ReferralTypeModel
  extends Model
  implements ModelRecord<IReferralTypeModel>
{
  referralTypeId: number;
  name: string;

  constructor(params?: Partial<IReferralTypeModel>) {
    super(params);

    this.referralTypeId = defaultTo(params?.referralTypeId, 0);
    this.name = defaultTo(params?.name, '');
  }
}
